export default __webpack_public_path__ + "static/media/42-min.3e6b8b1b.jpg";